<template>
  <section class="dashboard-panel" :class="[panelClass, { 'dashboard-panel--headerless': !title }]">
    <header v-if="title" class="dashboard-panel__header">
      <h2>{{ title }}</h2>
      <span v-if="meta" class="dashboard-panel__meta">{{ meta }}</span>
      <slot name="header" />
    </header>
    <div class="dashboard-panel__body">
      <slot />
    </div>
  </section>
</template>

<script>
export default {
  name: 'DashboardPanel',
  props: {
    title: { type: String, default: '' },
    meta: { type: String, default: '' },
    panelClass: { type: String, default: '' }
  }
}
</script>

<style lang="scss" scoped>
.dashboard-panel {
  position: relative;
  min-width: 0;
  min-height: var(--dashboard-card-min-height, 220px);
  overflow: hidden;
  background: linear-gradient(145deg, rgba(5, 39, 64, .92), rgba(3, 25, 45, .96));
  border: 1px solid var(--screen-border);
  border-radius: var(--screen-radius);
  box-shadow: inset 0 0 22px rgba(0, 145, 232, .08), 0 0 16px rgba(0, 24, 46, .36);
}

.dashboard-panel::before,
.dashboard-panel::after {
  position: absolute;
  width: 26px;
  height: 6px;
  content: '';
  pointer-events: none;
}

.dashboard-panel::before {
  top: -1px;
  left: 18px;
  border-top: 1px solid var(--screen-line);
}

.dashboard-panel::after {
  right: 18px;
  bottom: -1px;
  border-bottom: 1px solid var(--screen-line);
}

.dashboard-panel__header {
  display: flex;
  align-items: center;
  height: 42px;
  padding: 0 14px;
  border-bottom: 1px solid rgba(52, 123, 168, .18);
}

.dashboard-panel__header h2 {
  margin: 0;
  color: var(--screen-text);
  font-size: 18px;
  font-weight: 600;
  line-height: 1;
  letter-spacing: 0;
  text-shadow: 0 0 10px rgba(116, 200, 255, .22);
}

.dashboard-panel__meta {
  margin-left: auto;
  color: var(--screen-muted);
  font-size: 12px;
}

.dashboard-panel__body {
  height: calc(100% - 42px);
  min-height: calc(var(--dashboard-card-min-height, 220px) - 42px);
}

.dashboard-panel--headerless .dashboard-panel__body {
  height: 100%;
  min-height: var(--dashboard-card-min-height, 220px);
}
</style>
